import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useToast } from 'src/context/ToastProvider';
import { useUserContext } from 'src/context/UserProvider';
import seoConfig from '../seo.json';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useSessionContext } from 'src/context/SessionContextProvider';

import { get } from 'lodash';
import { createParticipantSessionToken, createSessionLog, verifyToken } from 'src/apis/session';
import { useGetSessionByIdQuery } from 'src/hooks/session.hooks';
import { SessionJoineeStatus, SessionStatus, UIGuestUser, UIUser } from 'types';
import { Loader } from 'ui';
import UnAuthorizedParticipantScreen from 'src/components/interviews/UnAuthorizedParticipantScreen';
import Seo from 'src/components/Seo';
import InterviewLayout from 'src/components/interviews/InterviewLayout';
import SessionNotStartedScreen from 'src/components/AlumniConnect/SessionNotStartedScreen';
import LiveSessionScreen from 'src/components/AlumniConnect/LiveSessionScreen';
import SessionEndedScreen from 'src/components/AlumniConnect/SessionEndedScreen';
import { isUserAdmin } from 'shared-utils';
import NewCreatingPositionLoader from 'src/components/position/NewCreatingPositionLoader';
const LiveSession = () => {
	const { user: levelUpUser, isAlumniConnectLoggedIn, isMentorLoggedIn } = useUserContext();
	const [user, setUser] = useState<UIGuestUser | UIUser | null>(levelUpUser);
	const { sessionId } = useParams();
	const toast = useToast();
	const navigate = useNavigate();
	const { setSession } = useSessionContext();
	const seoInfo = seoConfig['live-interview-js'];
	const [hasSessionStarted, setHasSessionStarted] = useState(false);
	const [hasSessionEnded, setHasSessionEnded] = useState<boolean>(false);
	const [notParticipant, setNotParticipant] = useState<boolean>(false);
	const [participantToken, setParticipantToken] = useState<string>('');
	const [isHost, setIsHost] = useState<boolean | null>(null);
	const [attendanceLogged, setAttendanceLogged] = useState(false);
	const [latestParticipantTokenCreated, setLatestParticipantTokenCreated] = useState(false);

	const [searchParams] = useSearchParams();

	const [jwtuser, setJwtUser] = useState<UIGuestUser>();
	const [isGuestUser, setIsGuestUser] = useState(false);
	const token = isAlumniConnectLoggedIn || isMentorLoggedIn ? '' : searchParams.get('token') || '';

	const verifyTokenMutation = useMutation(['verifyToken'], verifyToken, {
		onSuccess(data: any) {
			if (data?.user) setJwtUser(data?.user);
		},
		onError(error: Error) {
			toast({
				title: 'Invalid Token',
				type: 'error',
			});
		},
	});

	useEffect(() => {
		if (isAlumniConnectLoggedIn || isMentorLoggedIn) {
			//
		} else if (token) {
			// check for jwt token
			verifyTokenMutation.mutate({ token });
		}
	}, [isAlumniConnectLoggedIn, isMentorLoggedIn, token]);

	useEffect(() => {
		console.log('levelUpUser-----:', levelUpUser);
		setUser(levelUpUser || jwtuser || null);
	}, [jwtuser, levelUpUser]);

	useEffect(() => {
		if (jwtuser?.slug) {
			setIsGuestUser(true);
		}
	}, [jwtuser?.slug]);

	const createParticipantSessionTokenFn = useMutation(
		['createParticipantSessionToken'],
		createParticipantSessionToken,
		{
			onSuccess(data) {
				if (data?.token) setParticipantToken(data.token);
				setLatestParticipantTokenCreated(true);
			},
			onError(error: Error) {
				const errorMessage = get(error, ['response', 'data', 'message'], error.message);
				toast({
					type: 'error',
					title: errorMessage,
				});
			},
		},
	);
	const [hostId, setHostId] = useState<string | null>(null);

	useEffect(() => {
		const currentUserId = user?._id;
		if (currentUserId && !sessionResponse.isLoading) {
			if (hostId === currentUserId) {
				setIsHost(true);
			} else {
				setIsHost(false);
			}
		}
		sessionResponse.refetch();
	}, [hostId, user?._id]);

	useEffect(() => {
		if (sessionId && token) {
			sessionResponse.refetch();
		}
	}, [sessionId, token]);

	const sessionResponse = useGetSessionByIdQuery(
		sessionId,
		token,
		data => {
			if (!data.session) {
				// navigate('/dashboard');
				navigate('/my-applications');
			}
			setSession(data.session);
			const currentUserId = user?._id;
			setHostId(data.session?.host._id);
			console.log('currentUserId:', currentUserId);
			let pToken = data.session?.participantTokens?.find(pT => pT.participant?._id === currentUserId);
			if (isGuestUser) {
				pToken = data.session?.participantTokens?.find(pT => pT.guestParticipant?._id === currentUserId);
			}

			if (pToken && pToken.token) {
				console.log('inside ptoken', pToken, latestParticipantTokenCreated);
				if (!latestParticipantTokenCreated) handleCreateParticipantToken();
				else setParticipantToken(pToken.token);
				setNotParticipant(false);
			} else if (!currentUserId) {
				console.log('here 1: user not find');
				setNotParticipant(true);
			} else if (
				[data.session?.participant?._id, data.session?.host._id, data.session?.levelUpParticipant?._id].includes(
					currentUserId,
				) &&
				!latestParticipantTokenCreated
			) {
				handleCreateParticipantToken();
				setNotParticipant(false);
			} else if (levelUpUser?.role && isUserAdmin(levelUpUser?.role) && !latestParticipantTokenCreated) {
				handleCreateParticipantToken();
				setNotParticipant(false);
			} else {
				console.log('here 3: user not find');
				setNotParticipant(true);
			}
			if (data.session?.sessionStatus === SessionStatus.SCHEDULED) {
				setHasSessionStarted(false);
			} else if (data.session?.sessionStatus === SessionStatus.STARTED) {
				setHasSessionStarted(true);
			} else {
				setHasSessionEnded(true);
			}
		},
		() => {
			console.log('here 4: user not find');
			setNotParticipant(true);
		},
	);

	const addUserSessionLog = useMutation({
		mutationKey: 'createSessionLog',
		mutationFn: createSessionLog,
	});

	const handleCreateParticipantToken = () => {
		if (sessionId)
			createParticipantSessionTokenFn.mutate({
				sessionId: sessionId,
				participantSlug: jwtuser?.slug,
				token,
			});
	};

	useEffect(() => {
		const currentUserId = user?._id;
		if (currentUserId && sessionResponse.data && !attendanceLogged) {
			addUserSessionLog.mutate({
				sessionId: sessionResponse.data.session?.dyteMeetingId || '',
				participant: user._id,
				status: SessionJoineeStatus.JOINED,
				token,
			});
			setAttendanceLogged(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user?._id, sessionResponse.data]);

	useEffect(() => {
		if (sessionResponse.data?.session) setSession(sessionResponse.data.session);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [sessionResponse.data]);

	if (sessionResponse.isLoading || createParticipantSessionTokenFn.isLoading)
		return (
			// <Loader />
			<NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="!w-[30%] mx-auto " />
		);

	if (notParticipant) {
		if (sessionResponse.isLoading)
			return (
				// <Loader />
				<NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="!w-[30%] mx-auto " />
			);
		return (
			<div className="h-screen w-screen dark:bg-[#1f2023]">
				<UnAuthorizedParticipantScreen showNavbar={isHost ?? false} />
			</div>
		);
	} else if (sessionResponse.data) {
		if (hasSessionEnded) {
			return (
				<div className="h-screen w-screen dark:bg-[#1f2023]">
					<SessionEndedScreen />
				</div>
			);
		} else if (hasSessionStarted) {
			return (
				<>
					<Seo title={seoInfo.title} description={seoInfo.description} />
					<div className="h-screen w-full dark:bg-[#1f2023]">
						<InterviewLayout token={participantToken}>
							<LiveSessionScreen isHost={isHost ?? false} />
						</InterviewLayout>
					</div>
				</>
			);
		} else {
			return (
				<div className="h-screen w-screen dark:bg-[#1f2023]">
					{typeof isHost === 'boolean' && (
						<SessionNotStartedScreen session={sessionResponse.data.session} isHost={isHost ?? false} />
					)}
				</div>
			);
		}
	} else return <div />;
};

export default LiveSession;
